"use client";
import { Button } from "@/components/ui/button";
import SmileWomanMobile from "@/../public/SmileWomanMobile.webp";
import SmileWomanDesktop from "@/../public/SmileWomanDesktop.webp";
import { useRouter } from "next/navigation";
import { useSite } from "@/lib/hooks/site";
import { useClientTranslation } from "@/app/i18n/client";
import { useEffect, useMemo, useState } from "react";
import { Link } from "@/components/CustomLink";
import S3Image from "@/components/S3Image";
import { useTranslation } from "@/hooks/translationContext";

export default function CloseSaloons({
  district,
}: {
  district: {
    index: number;
    district: string;
  };
}) {
  const router = useRouter();
  const site = useSite();
  const { t } = useTranslation();

  const getImage = () => {
    const calltoaction = site?.setting?.design?.calltoaction;
    if (calltoaction?.["venue-detail-quote"]) {
      const url = `site/${site.id}/assets/${calltoaction["venue-detail-quote"]}`;
      return url;
    }

    return null;
  }

  const getHrefURL = () => {
    return `/${district.district}-${site.setting?.routes?.districtSpecificList}`;
  };

  const imageAlt = useMemo(
    () =>
      t("close-venues-image-alt", {
        site: site?.descriptions[0]?.title,
      }),
    [t, site],
  );

  const getMobileTitle = () => {
    return t("close-venues-mobile-button", {
      defaultValue: "Mekanları Gör",
    });
  };

  const getDesktopTitle = () => {
    return t("close-venues-desktop-button", {
      defaultValue: "Bölgenizdeki Mekanları Görmek İçin Tıklayın",
    });
  };

  return (
    <Link title={getDesktopTitle()} href={getHrefURL()}>
      <div className="lg:flex hidden gap-3 mt-20 items-end lg:max-w-[895px] bg-gradient-to-l from-lime-400 via-lime-500 to-green-500 rounded-[32px]">
        <div className="ml-2 absolute !h-[148px] !w-[140px]">
          <S3Image
            fill
            loader={!getImage() ? ({ src }) => src : undefined}
            src={getImage() || SmileWomanDesktop.src}
            title={imageAlt}
            alt={imageAlt}
          />
        </div>

        <div
          onClick={() =>
            router.push(
              `/${district.district}-${site.setting?.routes?.districtSpecificList}`,
            )
          }
          className="flex cursor-pointer h-[90px] justify-between items-center ml-[168px] pr-6 py-4 w-full"
        >
          <div className="flex w-full justify-between gap-4 items-center text-white whitespace-nowrap text-sm font-bold">
            <div>
              <span>
                {t("close-venues-title", {
                  defaultValue: "Bölgenizdeki Diğer Mekanlarıda İnceleyin",
                })}
              </span>
            </div>

            <div className="flex justify-end w-full">
              <Button
                variant="white"
                className="w-[361px] active: text-[#25D366]"
              >
                {getDesktopTitle()}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-14 flex lg:hidden">
        <div className="text-white w-full rounded-[32px] p-6 bg-gradient-to-l from-lime-400 via-lime-500 to-green-500 h-[142px] relative">
          <S3Image
            loader={!getImage() ? ({ src }) => src : undefined}
            sizes="163px"
            height={174}
            width={163}
            src={getImage() || SmileWomanMobile.src}
            alt={imageAlt}
            title={imageAlt}
            className="h-[174px] w-[163px] absolute -translate-x-7 left-0 bottom-0 "
          />

          <div className="flex pl-36 items-center">
            <div className="flex flex-col items-start gap-2">
              <div className="text-sm font-bold w-[181px]">
                {t("close-venues-title", {
                  defaultValue: "Bölgenizdeki Diğer Mekanlarıda İnceleyin",
                })}
              </div>

              <Button
                className="bg-white hover:bg-white text-[#25D366] text-center
                                text-sm font-bold whitespace-nowrap text-ellipsis !overflow-hidden px-4 py-3 justify-center md:py-[12px]"
              >
                <span>{getMobileTitle()}</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
